import {t} from 'i18next';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import {Typography} from '@mui/material';

const CancelEditProtocolIntelligenceModal = ({
  showModal,
  handleCancel = () => {},
  handleConfirm = () => {},
}: {
  showModal: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
}) => {
  return (
    <ArrModal
      showModal={showModal}
      onClose={() => {}}
      showClose={false}
      title={t('ai.review.protocolIntelligence.cancelEditProtocolModalTitle')}
      aria-label="cancel-edit-protocol-intelligence-modal"
      dataTestId="ai-review-protocolIntelligence-cancelEditProtocolModalTitle"
      buttons={[
        {
          id: t('ai.review.protocolIntelligence.cancelEditProtocolModalNo'),
          label: t('ai.review.protocolIntelligence.cancelEditProtocolModalNo'),
          onClick: handleCancel,
          variant: 'secondary',
          dataTestId:
            'ai-review-protocolIntelligence-cancelEditProtocolModalNo',
        },
        {
          id: t('ai.review.protocolIntelligence.cancelEditProtocolModalYes'),
          label: t('ai.review.protocolIntelligence.cancelEditProtocolModalYes'),
          onClick: handleConfirm,
          variant: 'primary',
          dataTestId:
            'ai-review-protocolIntelligence-cancelEditProtocolModalYes',
        },
      ]}
    >
      <Typography
        className="typo-text body2_size text-body-strong"
        data-testid={`ai-review-protocolIntelligence-cancelEditProtocolModalDescription`}
      >
        {t('ai.review.protocolIntelligence.cancelEditProtocolModalDescription')}
      </Typography>
    </ArrModal>
  );
};

export default CancelEditProtocolIntelligenceModal;
